import React, { FC } from 'react';
import styles from './text.module.scss';

export const TruncatedDefinitionFakeLink: FC = ({ children, ...rest }) => (
  <span {...rest} className={styles.link}>
    {children}
  </span>
);
